import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { CARDS } from "../data/cards";

function LetterBadge({ card }) {
  const outline = card.kind === "letter-outline";
  const color = outline ? "#f0761f" : card.fg;
  return (
    <div className="flex h-20 items-center justify-center sm:h-28">
      <div
        className="flex aspect-square items-center justify-center rounded-full font-extrabold"
        style={{
          height: "100%",
          border: `6px solid ${color}`,
          color,
          fontSize: "clamp(30px, 9vw, 58px)",
          lineHeight: 1,
        }}
      >
        {card.letter}
      </div>
    </div>
  );
}

function StarDivider({ color, starColor = "#f0761f" }) {
  return (
    <div className="mt-1 flex items-center justify-center gap-1.5">
      <span className="h-[2px] w-6 rounded" style={{ background: color, opacity: 0.85 }} />
      <Star size={13} fill={starColor} color={starColor} />
      <span className="h-[2px] w-6 rounded" style={{ background: color, opacity: 0.85 }} />
    </div>
  );
}

export default function CardGrid() {
  return (
    <section
      data-testid="card-grid"
      className="mx-auto grid max-w-2xl grid-cols-3 gap-2.5 px-2.5 sm:gap-4 sm:px-3"
      aria-label="Quick links"
    >
      {CARDS.map((card, i) => {
        const isImage = card.kind === "image";
        const white = card.bg === "#ffffff";
        const starColor = card.key === "morning-teer" ? "#f6c445" : "#f0761f";
        const cardBody = (
          <>
            {isImage ? (
              <div className="flex h-20 w-full items-center justify-center sm:h-28">
                <img
                  src={card.img}
                  alt={card.alt}
                  decoding="async"
                  className="h-full w-auto max-w-full object-contain"
                />
              </div>
            ) : (
              <LetterBadge card={card} />
            )}

            <div className="w-full text-center">
              <div
                className="text-[13px] font-extrabold leading-tight sm:text-lg"
                style={{ color: card.fg }}
              >
                {card.title}
              </div>
              <StarDivider color={card.fg} starColor={starColor} />
            </div>
          </>
        );

        const className =
          "teer-card fade-in flex flex-col items-center justify-between rounded-2xl px-1.5 pb-2 pt-2 shadow-md";
        const style = {
          background: card.bg,
          border: white ? "1px solid #e6eaef" : "none",
          animationDelay: `${i * 40}ms`,
        };

        if (card.external) {
          return (
            <a
              key={card.key}
              href={card.to}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={card.testId}
              className={className}
              style={style}
            >
              {cardBody}
            </a>
          );
        }

        return (
          <Link
            key={card.key}
            to={card.to}
            data-testid={card.testId}
            className={className}
            style={style}
          >
            {cardBody}
          </Link>
        );
      })}
    </section>
  );
}
